import { defineComponent as _defineComponent } from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMapLocation } from '@fortawesome/free-solid-svg-icons';
import Handsontable from 'handsontable';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import ModalPageSettingsContainer from '@/datura/assessments/containers/ModalPageSettingsContainer.vue';
import TableAssessmentsContainer from '@/datura/assessments/containers/TableAssessmentsContainer.vue';
import { TableDataAssessment } from '@/datura/assessments/handsontable/types';
import TheContentbar from '@/layout/components/TheContentbar.vue';
import ThePageSkeleton from '@/layout/components/ThePageSkeleton.vue';
import CompanySwitch from '@/shared/components/CompanySwitch.vue';
import DropdownPageOptions from '@/shared/components/DropdownPageOptions.vue';
import ModalTableExport from '@/shared/components/ModalTableExport.vue';
import ProcessOrderSwitch from '@/shared/components/ProcessOrderSwitch.vue';
import SearchBar from '@/shared/components/SearchBar.vue';
import Button from '@/shared/components/buttons/Button.vue';
import ButtonDropdown from '@/shared/components/buttons/ButtonDropdown.vue';
import { availableFeatures } from '@/shared/storeDynamicFeatures';
import { useStore } from '@/store';

import assessmentsColumns from './handsontable/columns';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageDroneAssessment',
  setup(__props) {

library.add(faMapLocation);

const router = useRouter();

const searchTerm = ref('');
const modalPageSettings = ref<InstanceType<ModalPageSettingsContainer>>();
const editMode = ref(false);
const store = useStore();
const tableContainerRef = ref<any>(null);
const modalTableExport = ref<any>(null);
const hot = ref<Handsontable | null>(null);
const showModalExport = ref(false);

const pageFeatureEnabled = computed<boolean>(() =>
  store.getters.currentCompaniesHaveFeatureEnabled(availableFeatures.FEATURE_DATURA_CONTROL),
);
const pageFeatureVisible = computed<boolean>(() =>
  store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_DATURA_CONTROL),
);
const pageFeatureReadOnly = computed<boolean>(() =>
  store.getters.currentCompaniesHaveFeatureReadonly(availableFeatures.FEATURE_DATURA_CONTROL),
);

const tableData = computed<TableDataAssessment[]>(() => store.getters['datura/assessments/tableDataAssessments']);

const tableColumns = computed<any>(() => {
  if (!hot.value || hot.value.isDestroyed) return null;
  const cols = hot.value.getSettings().columns;
  return cols;
});

const tableRef = computed<any>(() => {
  if (!tableContainerRef.value) return null;
  return tableContainerRef.value.$refs.table;
});

const visibleRowIds = computed<Set<string>>(() => {
  if (!hot.value) return new Set();
  const uniqueIds = new Set(hot?.value.getDataAtProp('id') as unknown as string);
  return uniqueIds;
});

const allRowsVisible = computed<boolean | null>(() => {
  if (!tableRef.value) return null;
  return tableRef.value.allRowsVisible;
});

function onShowModalExport(filterSelected: boolean) {
  showModalExport.value = true;
  setTimeout(() => {
    if (filterSelected) exportSelected();
    else exportData();
  }, 50);
}

async function exportSelected() {
  if (!modalTableExport.value) return;
  const { exportFiltered, okay } = await modalTableExport.value.show();

  if (!okay) {
    return;
  }

  let selectedRows = tableRef.value.selectedRows();
  if (selectedRows.length === 0) {
    selectedRows = Array.from(tableRef.value.groupedTableDataIds);
  }
  let rowIds: string[] = [];

  if (exportFiltered) {
    const filteredSelectedRows = selectedRows.filter((selectedRow) => visibleRowIds.value.has(selectedRow));
    rowIds = filteredSelectedRows;
  } else {
    rowIds = selectedRows;
  }

  modalTableExport.value.onExportSelected(rowIds);
}

async function exportData() {
  if (!modalTableExport.value) return;
  const { exportFiltered, okay } = await modalTableExport.value.show();

  if (!okay) {
    return;
  }

  let rowIds: string[] = [];

  if (exportFiltered) {
    rowIds = Array.from(visibleRowIds.value);
  } else {
    rowIds = Array.from(tableRef.value.groupedTableDataIds);
  }

  modalTableExport.value.onExportSelected(rowIds);
}

function onShowSettings() {
  modalPageSettings.value?.show();
}

return { __sfc: true,router, searchTerm, modalPageSettings, editMode, store, tableContainerRef, modalTableExport, hot, showModalExport, pageFeatureEnabled, pageFeatureVisible, pageFeatureReadOnly, tableData, tableColumns, tableRef, visibleRowIds, allRowsVisible, onShowModalExport, exportSelected, exportData, onShowSettings, ModalPageSettingsContainer, TableAssessmentsContainer, TheContentbar, ThePageSkeleton, CompanySwitch, DropdownPageOptions, ModalTableExport, ProcessOrderSwitch, SearchBar, Button, ButtonDropdown, assessmentsColumns }
}

})